'use client';

import React from 'react';
import NeedReno, {needRenoProps} from 'components/commercetools-ui/organisms/content/need-reno-section';
import { TasticProps } from 'frontastic/tastics/types';


const NeedRenoSliderTastic  = ({ data }: TasticProps<needRenoProps>) => {

    return <NeedReno data={data.data.dataSource} />;
};

export default NeedRenoSliderTastic;